export default {
    'errno': 0,
    'msg': 'ok',
    'data': {
        'prize_info': {
            'title': ['恭喜获得现金'],
            'type': 0,
            num: 0.5,
            unit: '元',
            'button_text': '开心收下',
            'ext_text': '前往新地点，继续逛逛拆红包',
            'button_image': 'https://cjh-amis.cdn.bcebos.com/2022-11/1669732873270/packet-btn.png',
            'back_image': 'https://cjh-amis.cdn.bcebos.com/2022-11/1669732850642/packet-bg.png'
        }
        // 'prize_info': {
        //     'title': ['今天拆红包机会已用完', '明天再来吧'],
        //     'type': -1,
        //     num: 0.5,
        //     unit: '元',
        //     'button_text': '好的',
        //     'ext_text': '继续逛逛拆红包',
        //     'button_image': 'https://cjh-amis.cdn.bcebos.com/2022-11/1669732873270/packet-btn.png',
        //     'back_image': 'https://cjh-amis.cdn.bcebos.com/2022-11/1669793617102/packet-bg1.png'
        // }
    }
};